import React from 'react';
import './NewsSection.css';
import LanternLabs2 from '../assets/LanternLabs2.png';
import LanternLabs3 from '../assets/LanternLabs3.png';
import whiteLOGO from '../assets/whiteLOGO.png';
import lantern_header from '../assets/lantern_header.svg';

const NewsSection = () => {
    return (
        <section className="news-section-container" id="news-section">
            {/* Background Text Decoration */}
            <div className="news-bg-text-container">
                <div className="news-bg-text-wrapper">
                    <h1 className="news-bg-text lantern">LANTERN</h1>
                </div>
                <div className="news-bg-text-wrapper">
                    <h1 className="news-bg-text labs">LABS</h1>
                </div>
            </div>

            {/* Scattered Decorative Images */}
            <img src={LanternLabs2} alt="" className="news-decor-img decor-1" />
            <img src={LanternLabs3} alt="" className="news-decor-img decor-2" />
            <img src={LanternLabs2} alt="" className="news-decor-img decor-3" />
            <img src={LanternLabs3} alt="" className="news-decor-img decor-4" />
            <img src={LanternLabs2} alt="" className="news-decor-img decor-5" />
            <img src={LanternLabs3} alt="" className="news-decor-img decor-6" />
            <img src={LanternLabs2} alt="" className="news-decor-img decor-7" />
            <img src={LanternLabs3} alt="" className="news-decor-img decor-8" />
            <img src={LanternLabs2} alt="" className="news-decor-img decor-9" />

            <div className="news-content-wrapper">
                {/* Logo Section */}
                <div className="news-logo-container">
                    {/* Using the Main Logo from public folder as placeholder for the specific logo in design */}
                    <img
                        src={whiteLOGO}
                        alt="Lantern Pharma Logo"
                        className="news-logo"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = lantern_header;
                        }}
                    />
                </div>

                {/* Content Section */}
                <div className="news-text-container">
                    {/* Background Ellipse */}
                    <div className="news-bg-ellipse"></div>

                    <p className="news-description">
                        <span className="font-medium">Lantern Labs </span>
                        unites Lantern Pharma’s expertise in AI, oncology, and computational drug development to turn complex biomedical data into scalable AI modules. It’s where we productionize advanced models, accelerate discovery, and evolve RADR®-powering innovations like <span className="font-medium">PredictBBB</span>, <span className="font-medium">withZeta</span>, and <span className="font-medium">LBx-AI</span> to shape the future of cancer therapy.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default NewsSection;
